export enum LanguageCode {
  FR = 'fr',
  EN = 'en',
}
